import { useEffect, useState } from 'react';
import { BasePick } from '../domain/types';
import { loadPlayerPhotos } from '../services/playerPhotos';

export function PlayerPhoto({ pick, className = '', showTeamBadge = true, fallbackLabel }: { pick: BasePick; className?: string; showTeamBadge?: boolean; fallbackLabel?: string }) {
  const [images, setImages] = useState<{ photo?: string; teamLogo?: string }>();
  useEffect(() => {
    let alive = true;
    void loadPlayerPhotos([pick]).then(result => { if (alive) setImages(result.get(pick.id)); });
    return () => { alive = false; };
  }, [pick.id, pick.player, pick.sport, pick.game]);
  const fallback = pick.sport === 'NBA' ? 'NBA' : 'NHL';
  const usePlayerPortrait = !/tracker-team-logo|parlay-team-logo|builder-team-logo/.test(className);
  return <span className={`player-photo ${className}`}>
    {usePlayerPortrait && images?.photo && <img className="player-photo-main" src={images.photo} alt={`${pick.player}`} loading="lazy" onError={event => { event.currentTarget.style.display = 'none'; }} />}
    {!usePlayerPortrait && images?.teamLogo && <img className="player-photo-main" src={images.teamLogo} alt="" loading="lazy" />}
    {usePlayerPortrait && !images?.photo && <span aria-hidden="true">{fallbackLabel ?? fallback}</span>}
    {usePlayerPortrait && showTeamBadge && images?.teamLogo && <span className="player-team-badge"><img src={images.teamLogo} alt="" loading="lazy" /></span>}
  </span>;
}
